import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const IconPerks = (props?: SvgProps) => (
  <svg
    viewBox="0 0 36 36"
    fill="var(--default-icon-color)"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path d="M34 16.78A2.22 2.22 0 0 0 32.71 12.78L23.71 12.44A0.23 0.23 0 0 1 23.51 12.29L20.4 3.89A2.22 2.22 0 0 0 16.23 3.89L13.13 12.32A0.23 0.23 0 0 1 12.93 12.47L3.93 12.81A2.22 2.22 0 0 0 2.64 16.81L9.7 22.36A0.23 0.23 0 0 1 9.78 22.6L7.35 31.21A2.22 2.22 0 0 0 10.73 33.66L18.19 28.66A0.22 0.22 0 0 1 18.44 28.66L25.9 33.66A2.2 2.2 0 0 0 28.45 33.66A2.2 2.2 0 0 0 29.28 31.26L26.83 22.62A0.22 0.22 0 0 1 26.91 22.38Z" />
  </svg>
)
